import { chains } from '../libs/rainbow';
import { chainIcons } from '../constants/network';

interface ChainInfo {
  name: string;
  explorerUrl: string;
  logo: string;
}

export function getChainInfo(chainId: number): ChainInfo {
  const chain = Object.values(chains).find((c) => c.id === chainId);

  if (!chain) {
    return {
      name: 'Unknown Chain',
      explorerUrl: '',
      logo: '',
    };
  }

  return {
    name: chain.name,
    explorerUrl: chain.blockExplorers?.default?.url || '',
    logo: chain.iconUrl || chainIcons[chainId]?.icon,
  };
}

export function getExplorerTransactionLink(chainId: number, txHash: string): string {
  const { explorerUrl } = getChainInfo(chainId);
  if (!explorerUrl) return '';

  return `${explorerUrl}/tx/${txHash}`;
}
